import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Button } from 'antd';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { Link } from 'react-router-dom';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import { BUYER_NOTIFICATION_APPROVALS_TYPES_MAP } from '../../utils/NotificationUtils';
import { userNotificationsRestCrudThunksForSupplier } from '../../thunks/user_notifications_thunks';
import { isInternalTech } from '../../utils/AuthUtils';
import { supplierSettingsRestCrudThunksForSupplier } from '../../thunks/supplier_settings_thunks';
import OverviewShell from '../overview_shell/OverviewShell';

require('./SupplierNotificationsOverviewPage.less');

const SupplierNotificationsOverviewPage: React.FC<any> = ({
	fetchUserNotificationsCountForSupplier,
	history,
	currentUser,
	location,
	userNotifications,
	childRoutes,
	getSupplierSettings,
}) => {
	useEffect(() => {
		if (currentUser) {
			fetchUserNotificationsCountForSupplier(
				{
					isActionRequired: true,
					pendingApproval: true,
					notificationTypes: BUYER_NOTIFICATION_APPROVALS_TYPES_MAP.map((filter) => {
						if (filter.children && filter.children.length > 0) {
							return filter.children.map((child) => child.key);
						}
						return filter.key;
					}).flat(),
				},
				'NotificationsApprovals'
			);
			getSupplierSettings(currentUser.email);
		}
	}, [currentUser, fetchUserNotificationsCountForSupplier, getSupplierSettings]);

	const handleTabChange = useCallback(
		(key) => {
			history.push(`/supplier/inbox/overview/${key}`);
		},
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history]
	);

	const isPrivateSupplier = isInternalTech(currentUser);
	const unreadCount = nullSafeGet('counts.TASKS_NOTIFICATIONS', userNotifications);
	const unreadWaitingonMeCount = nullSafeGet('counts.NotificationsApprovals', userNotifications);

	const tabs = [
		{
			key: 'important',
			name: unreadCount ? (
				<>
					Important <span className="text-base">({unreadCount})</span>
				</>
			) : (
				'Important'
			),
		},
		...(isPrivateSupplier
			? [
					{
						key: 'approvals',
						name: unreadWaitingonMeCount ? (
							<>
								Approvals <span className="text-base ">({unreadWaitingonMeCount})</span>
							</>
						) : (
							'Approvals'
						),
					},
			  ]
			: []),
		{
			key: 'notes',
			name: 'Notes',
		},
		{
			key: 'status',
			name: 'Status Updates',
		},
	];

	const settingsButton = (
		<div className="flex  ">
			<Link
				to={getLinkWIthBackLinkParams(
					location,
					'Back to Inbox',
					`/supplier/settings/notifications`
				)}
				style={{ marginRight: 16 }}
			>
				<Button ghost={true}>Settings</Button>
			</Link>
		</div>
	);

	return (
		<>
			<Route
				path="/supplier/inbox/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/inbox/overview/important',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Inbox"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="supplierNotificationsPage"
				headerRightContent={settingsButton}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	userNotifications: state.user_notifications,
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch) => ({
	fetchUserNotificationsCountForSupplier: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.countBy(params, countName)),
	getSupplierSettings: (email) =>
		dispatch(supplierSettingsRestCrudThunksForSupplier.readOne(email)),
});
export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierNotificationsOverviewPage)
);
